/* @generated */

// src/assets/ui-icon/line/block-quote.tsx
import * as React from "react";
var BlockQuoteLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M19.073 9a.808.808 0 0 0-.809.808v1.617c0 .446.362.808.809.808h.835c-.08.348-.206.626-.36.85-.224.327-.578.64-1.13.901l.28 1.512c1.847-.73 2.772-2.07 2.799-4.05V9.807A.808.808 0 0 0 20.69 9h-1.616Zm-4.938 0a.808.808 0 0 0-.808.808v1.617c0 .446.362.808.808.808h.835a2.43 2.43 0 0 1-.359.85c-.224.327-.578.64-1.13.901l.28 1.512c1.844-.73 2.77-2.066 2.799-4.043V9.808A.808.808 0 0 0 15.752 9h-1.617Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 7.5h-19V6h19v1.5Zm-10 5.5h-9v-1.5h9V13Zm10 5.5h-19V17h19v1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  BlockQuoteLine
};
